/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_Sage_Crane_NoteInputs */

const en_fast_sage_crane_note = /** @type {(inputs: Fast_Sage_Crane_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing status`)
};

const de_fast_sage_crane_note = /** @type {(inputs: Fast_Sage_Crane_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitungsstatus`)
};

/**
* | output |
* | --- |
* | "Processing status" |
*
* @param {Fast_Sage_Crane_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_sage_crane_note = /** @type {((inputs?: Fast_Sage_Crane_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_Sage_Crane_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_sage_crane_note(inputs)
	return de_fast_sage_crane_note(inputs)
});